import { useDocumentData } from "react-firebase-hooks/firestore";
import { collection, doc, setDoc } from "firebase/firestore";
import { useSessionActivity } from "hooks/useSessionActivity/useSessionActivity";
import {
  useFirebaseRef as useSessionFirebaseRef,
  useSessionContext,
} from "hooks/useSession";

export const useFirebaseRef = (activityId) => {
  const { session } = useSessionContext();
  const sessionId = session?.id || "SESSIONNOTFOUND";
  const ref = useSessionFirebaseRef(sessionId);
  const { activityId: sessionActivityId } = useSessionActivity();

  if (!ref) return null;
  
  const activitiesCollection = collection(ref, "activities");
  return doc(activitiesCollection, activityId || sessionActivityId);
};

export const useActivity = (activityId) => {
  const { session } = useSessionContext();
  const sessionRef = useSessionFirebaseRef(session?.id || "SESSIONNOTFOUND");
  const ref = useFirebaseRef(activityId);
  const [activity, loading, error] = useDocumentData(ref);

  const update = async (data, id) => {
    let docRef;
    
    if (id && sessionRef) {
      const activitiesCollection = collection(sessionRef, "activities");
      docRef = doc(activitiesCollection, id);
    } else {
      docRef = ref;
    }

    if (!docRef) {
      console.error("No valid document reference for update");
      return Promise.reject(new Error("No valid document reference"));
    }

    return setDoc(docRef, data, { merge: true });
  };

  return { activity, loading, error, update, session };
};
